import { getLifecycleStage } from 'features/libra/lifecycle/lifecycleStageHelpers'
import type { LifecycleConfig } from 'features/libra/lifecycle/lifecycleTypes'
import startCase from 'lodash/startCase'

import type { LibraTicket } from './libraTicketsApi'

export interface TicketDisplayDetails {
  title: string
  versionLabel: string
  statusLabel: string
}

export function getTicketDisplayDetails(
  ticket: LibraTicket,
  lifecycleConfig?: LifecycleConfig
): TicketDisplayDetails {
  return {
    title: ticket.title || ticket.id,
    versionLabel: `V${ticket.version}`,
    statusLabel:
      getLifecycleStage(ticket, lifecycleConfig)?.name ??
      (ticket.ticketStatus
        ? startCase(ticket.ticketStatus)
        : ticket.workflowComplete
          ? 'Completed'
          : 'In Progress'),
  }
}

export function getTicketDisplayLabel(
  ticket: LibraTicket,
  lifecycleConfig?: LifecycleConfig,
  options?: { includeId?: boolean }
): string {
  const { title, versionLabel, statusLabel } = getTicketDisplayDetails(
    ticket,
    lifecycleConfig
  )
  const idLabel = options?.includeId ? ` — ID: ${ticket.id}` : ''

  return `${title} (${versionLabel}) — ${statusLabel}${idLabel}`
}
